module.exports = __webpack_public_path__ + "static/media/STRENGTH_COLOUR.8cdf21fc.png";